import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const CheckCircleIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Check Circle</title>
    <path d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM3.85 11.085L8.69 15.925L16.51 8.105L14.385 5.985L8.69 11.68L5.97 8.965L3.85 11.085Z"/>
  </IconBase>
);
